import { useToast } from "../../hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "../ui/toast";

const getToastAccentClass = (title, variant) => {
  const normalizedTitle = String(title || "").toLowerCase();

  if (
    variant === "destructive" ||
    normalizedTitle.includes("error") ||
    normalizedTitle.includes("failed") ||
    normalizedTitle.includes("rejected")
  ) {
    return "bg-red-500";
  }

  if (
    normalizedTitle.includes("warning") ||
    normalizedTitle.includes("required") ||
    normalizedTitle.includes("discard") ||
    normalizedTitle.includes("select") ||
    normalizedTitle.includes("choose")
  ) {
    return "bg-amber-500";
  }

  if (
    normalizedTitle.includes("saved") ||
    normalizedTitle.includes("created") ||
    normalizedTitle.includes("updated") ||
    normalizedTitle.includes("assigned") ||
    normalizedTitle.includes("approved") ||
    normalizedTitle.includes("sent") ||
    normalizedTitle.includes("deleted")
  ) {
    return "bg-green-500";
  }

  return "bg-blue-500";
};

function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider
      swipeDirection="right"
      duration={4000}
    >
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const accentClass = getToastAccentClass(title, props.variant);

        return (
          <Toast
            key={id}
            {...props}
            className="
              relative overflow-hidden bg-white shadow-[0_16px_42px_rgba(15,23,42,0.16)] border border-gray-200/90
              rounded-xl px-4 py-3 pl-5
              data-[state=open]:animate-in 
              data-[state=closed]:animate-out 
              data-[state=closed]:fade-out-80 
              data-[state=open]:fade-in-80
            "
          >
            <div className={`absolute left-0 top-0 h-full w-1 ${accentClass}`} />
            <div className="grid gap-1.5 pr-2">
              <div className="text-[10px] font-semibold uppercase tracking-wider text-blue-600">
                Seismic Connect • Healthcare Intelligence
              </div>
              {title && (
                <ToastTitle className="text-sm font-semibold leading-5 text-gray-900">
                  {title}
                </ToastTitle>
              )}
              {description && (
                <ToastDescription className="text-sm leading-5 text-gray-600">
                  {description}
                </ToastDescription>
              )}
            </div>

            {action}
            <ToastClose />
          </Toast>
        );
      })}

      <ToastViewport
        className="
          fixed bottom-6 right-6 
          flex flex-col gap-3 
          z-[99999] 
          outline-none
        "
      />
    </ToastProvider>
  );
}

export { Toaster };
